module.exports = __webpack_public_path__ + "static/media/help-chat.d5d3bc67.svg";